import { p as i, b as e } from "./abstract-base-CzLmw6_x-Ds3dPjNU.js";
import { t as s } from "./beacon-primitive-ChVMWFlW-Df2Js5lw.js";
var u = Object.defineProperty, r = (o, p, n, b) => {
  for (var t = void 0, a = o.length - 1, c; a >= 0; a--)
    (c = o[a]) && (t = c(p, n, t) || t);
  return t && u(p, n, t), t;
};
class l extends s(i) {
  constructor() {
    super(...arguments), this.index = 0, this.label = "", this.color = "", this.value = "";
  }
}
r([
  e({ reflect: !0 })
], l.prototype, "index");
r([
  e({ attribute: "label", alternateSlot: "legend-label", sync: !1 })
], l.prototype, "label");
r([
  e({ reflect: !0 })
], l.prototype, "color");
r([
  e({ attribute: "value", alternateSlot: "legend-value", sync: !1 })
], l.prototype, "value");
export {
  l as r
};
